import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  for: "props.name",
  class: "mb-5 font-medium"
}
const _hoisted_3 = {
  key: 0,
  class: "text-error"
}
const _hoisted_4 = ["placeholder", "name", "disabled"]
const _hoisted_5 = ["onClick"]

import { ref, onMounted, computed, watch } from "vue"
  import inputVue from "./InputTemplate.vue"
  import ggl from "@/utils/google"
  interface Props {
    modelValue: string
    name: string
    label?: string
    labelRequired?: boolean
    locationType?: "city" | "country"
    placeholder?: string
    disabled?: boolean
    floatingSuggestions?: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'locationTemplate',
  props: {
    modelValue: null,
    name: null,
    label: { default: undefined },
    labelRequired: { type: Boolean },
    locationType: { default: undefined },
    placeholder: { default: undefined },
    disabled: { type: Boolean },
    floatingSuggestions: { type: Boolean, default: true }
  },
  emits: ["location"],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: string, name: string, label: string, labelRequired?: boolean, locationType: "city" | "country", placeholder: string, disabled?: boolean, floatingSuggestions: boolean }

  const suggestion = ref<any[]>([])
  const session = ref<any>()
  const service = ref<any>()
  const places = ref<any>()

  
  
  const location = ref("")
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  let predictNow = setTimeout(() => {}, 500)

  /**
   * request to google map api
   */
  const prediction = () => {
    clearTimeout(predictNow)
    predictNow = setTimeout(() => {
      if (location.value === null || location.value.length < 3) suggestion.value = []
      else {
        if (!session.value) init()
        service.value.getPlacePredictions(
          {
            input: location.value,
            sessionToken: session.value,
            type: ["(cities)", "establishment", "address"],
          },
          (predictions: any, status: any) => {
            suggestion.value = []
            // eslint-disable-next-line no-undef
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              suggestion.value = predictions
            }
          }
        )
      }
    }, 500)
  }

  /**
   * get the place information
   * for saving the data
   */
  const onSelected = (loc: any) => {
    // full_address, street, postal code, country, state, city, coordinates, area
    const request = {
      placeId: loc.place_id,
      fields: [
        "formatted_address", //full_address
        "geometry", // area and coordinates
        "address_components",
        "name",
      ],
    }
    places.value.getDetails(request, (result: any, status: any) => {
      if (status === "OK") {
        const response = ggl.getAddress(result) as any
        response.coordinates = {
          lat: result.geometry.location.lat() || 0,
          long: result.geometry.location.lng() || 0,
        }
        location.value = response.full_address
        if (props.locationType === "city") location.value = response.city
        if (props.locationType === "country") location.value = response.country
        emit("location", response)
      }
      suggestion.value = []
    })
  }

  /**
   * initializing google api
   */
  const init = () => {
    const inputPlace = document.getElementById("location-address")
    // eslint-disable-next-line no-undef
    session.value = new google.maps.places.AutocompleteSessionToken()
    // eslint-disable-next-line no-undef
    service.value = new google.maps.places.AutocompleteService()
    // eslint-disable-next-line no-undef
    places.value = new google.maps.places.PlacesService(inputPlace as HTMLInputElement)
  }

  /**
   * select of location
   */
  const selectFirst = () => {
    location.value = ""
    emit("location", {
      city: "",
      country: "",
      full_address: location.value,
      coordinates: null,
      postal_code: null,
      state: null,
      street: null,
    })
    suggestion.value = []
  }

  onMounted(() => {
    // eslint-disable-next-line no-undef
    if (google) init()
  })
  watch(
    () => props.modelValue,
    (val) => {
      if (val !== location.value) location.value = val
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createTextVNode(_toDisplayString(props.label) + " ", 1),
      (props.labelRequired)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "location-address",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((location).value = $event)),
      type: "text",
      placeholder: props.placeholder || 'Address',
      name: props.name,
      class: "h-[45px] w-full rounded-xl pl-5 text-black bg-gray-highlight outline-none transition ease-out duration-200 my-2",
      disabled: __props.disabled,
      onInput: prediction
    }, null, 40, _hoisted_4), [
      [_vModelText, location.value]
    ]),
    _createVNode(inputVue, {
      modelValue: location.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((location).value = $event)),
      name: props.name,
      "input-class": "hidden"
    }, null, 8, ["modelValue", "name"]),
    (suggestion.value.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["w-full flex flex-col gap-2 shadow-base bg-white rounded-b-md p-2 z-100", { absolute: __props.floatingSuggestions }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestion.value, (loc) => {
            return (_openBlock(), _createElementBlock("div", {
              key: loc.place_id,
              class: "text-black hover:bg-primary-violet hover:text-white rounded-md cursor-pointer px-4 py-2",
              onClick: ($event: any) => (onSelected(loc))
            }, _toDisplayString(loc.description), 9, _hoisted_5))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})